module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": ("animated " + (_vm.settingsObj.animation))
    }
  }, [_c('v-layout', {
    staticClass: "detail-accordion",
    attrs: {
      "row": "",
      "wrap": "",
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": "",
      "lg6": "",
      "offset-lg3": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "full-screen": _vm.$vuetify.breakpoint.xsOnly,
      "popout": ""
    }
  }, _vm._l((this[_vm.endpoint]), function(item, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      class: [("" + (_vm.settingsObj.themeColor)), 'lighten-1', "white--text", 'mb-1'],
      attrs: {
        "transition": "slide-x-transition",
        "ripple": ""
      }
    }, [_c('div', {
      staticClass: "mt-1 mb-1",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.img,
        "alt": "avatar"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "ml-2 "
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.date))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('small', [_vm._v(_vm._s(item.relationship))])])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })])], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37711cea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailAccordion.vue
// module id = 462
// module chunks = 0